import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { PaymentType } from "@/interfaces/payment-type.interface";
import { PaymentTypeMessages } from "@/messages/platforms/talk2PayHome/payment-type.messages";

import { PAYMENT_TYPE_TABLE_COLUMNS } from "../../constants";
import { PaymentTypeTableRow } from "./row";

interface Props {
  items: PaymentType[];
  messages: PaymentTypeMessages;
  onRemove: (item: PaymentType) => void;
  onEdit: (item: PaymentType) => void;
  handleOpen: () => void;
  disableAdd?: boolean;
}

export function PaymentTypeTable({ items, messages, onRemove, onEdit, handleOpen, disableAdd = false }: Props) {
  const columns = PAYMENT_TYPE_TABLE_COLUMNS(messages);

  return (
    <MDBox width="100%" textAlign="center" mx="auto">
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox />
        <Tooltip
          title={disableAdd ? "Todas as formas de pagamento já foram cadastradas." : ""}
          placement="left"
        >
          <span>
            <MDButton
              variant="gradient"
              color="dark"
              endIcon={<AddCircleOutlineIcon />}
              onClick={handleOpen}
              disabled={disableAdd}
            >
              {messages.newPaymentTypeButtonLabel}
            </MDButton>
          </span>
        </Tooltip>
      </MDBox>

      <MDBox mt={1}>
        <Grid container spacing={3}>
          <TableContainer sx={{ marginTop: 1 }}>
            <Table stickyHeader aria-label="payment types table">
              <TableHead>
                <TableHeaderRow>
                  {columns.map((label, index) => (
                    <HeaderTableCell key={`${index}-${label}`}>{label}</HeaderTableCell>
                  ))}
                </TableHeaderRow>
              </TableHead>
              <TableBody>
                {items.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <MDTypography variant="h6" color="text" fontWeight="regular">
                        {messages.emptyTableMessage}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                ) : (
                  items.map((item, index) => (
                    <PaymentTypeTableRow
                      key={item.id}
                      item={item}
                      index={index}
                      messages={messages}
                      onRemove={onRemove}
                      onEdit={onEdit}
                    />
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </MDBox>
    </MDBox>
  );
}
